module.exports = __webpack_public_path__ + "static/media/postgresql-icon.96889989.svg";